var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgComment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.381592 3.1708C0.381592 1.95248 1.36923 0.964844 2.58754 0.964844H10.529C11.7473 0.964844 12.7349 1.95248 12.7349 3.1708V7.5827C12.7349 8.80102 11.7473 9.78866 10.529 9.78866H7.16522L4.4629 12.1532C3.90378 12.6424 3.02874 12.2454 3.02874 11.5024V9.78866H2.58754C1.36923 9.78866 0.381592 8.80102 0.381592 7.5827V3.1708ZM2.58754 1.84722C1.85656 1.84722 1.26397 2.43981 1.26397 3.1708V7.5827C1.26397 8.31369 1.85656 8.90627 2.58754 8.90627H3.91112V11.4635L6.83368 8.90627H10.529C11.26 8.90627 11.8525 8.31369 11.8525 7.5827V3.1708C11.8525 2.43981 11.26 1.84722 10.529 1.84722H2.58754Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.d31188d1.svg";
export { ForwardRef as ReactComponent };